import { useContext, useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import AddOutlined from '@material-ui/icons/AddOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import { ActionButton } from 'components/common/buttons'

import { TableComponent } from 'components/common/table-components'

import { get, isEmpty } from 'lodash'
import SearchComponent from 'components/common/search'
import { StatusComponent } from 'components/common/others'
import enums from 'Constants/enums'
import AddSites from './add-sites'
import { MainContext } from 'components/Main/provider'
import getUserRole from 'helpers/getUserRole'
import { Toast } from 'Snackbar/useToast'
import getActiveUserSitesAndRoles from 'Services/facilities/get-usersites-roles'
import { camelizeKeys } from 'helpers/formatters'
import updateClientCompany from 'Services/updateClientCompany'
import UpdateActiveSiteService from 'Services/UpdateActiveSiteService'
import { getApplicationStorageItem } from 'helpers/getStorageItem'
import updateActiveSiteAction from 'Actions/updateActiveSiteAction'
import $ from 'jquery'
import ViewSite from './ViewSite'

const Sites = ({ companyId, loading, siteList, clientCompanies, stateData, reFetch }) => {
  const [searchString, setSearchString] = useState('')
  const [anchorObj, setAnchorObj] = useState({})
  const [isOpenAddSite, setOpenAddSite] = useState(false)
  const [isOpenEditSite, setOpenEditSite] = useState(false)
  const [isOpenViewSite, setOpenViewSite] = useState(false)
  const [rows, setRows] = useState([...siteList])

  const loginData = JSON.parse(localStorage.getItem('loginData'))
  const { setLoginSiteData, setRefetchAppMenuContext } = useContext(MainContext)
  const checkUserRole = new getUserRole()

  const getStatus = status => {
    const statusLabel = enums.USER_STATUS_CHIPS.find(d => d.value === status)
    return statusLabel ? <StatusComponent color={statusLabel?.color} label={statusLabel?.label} size='small' /> : 'N/A'
  }

  const columns = [
    {
      name: 'Site Name',
      render: d => {
        return get(d, 'siteName', 'N/A')
      },
    },
    {
      name: 'Site Code',
      render: d => {
        return get(d, 'siteCode', 'N/A')
      },
    },
    {
      name: 'Status',
      render: d => {
        return getStatus(d.status)
      },
    },
    {
      name: 'Actions',
      render: d => (
        <div className='d-flex align-items-center'>
          <ActionButton action={e => handleAction(e, 'EDIT', d)} icon={<EditOutlinedIcon fontSize='small' />} tooltip='EDIT' />
        </div>
      ),
    },
  ]

  useEffect(() => {
    let filteredRows = [...siteList]
    if (!isEmpty(searchString)) {
      filteredRows = siteList.filter(x => (x.siteName !== null && x.siteName.toLowerCase().includes(searchString.toLowerCase())) || (x.siteCode !== null && x.siteCode.toLowerCase().includes(searchString.toLowerCase())))
    } else {
      filteredRows = [...siteList]
    }
    setRows(filteredRows)
  }, [searchString, siteList])

  const handleAction = async (event, type, data) => {
    event.stopPropagation()
    setAnchorObj(data)
    if (type === 'EDIT') setOpenEditSite(true)
  }

  // change site
  const handleSiteRadioClick = ({ siteId, siteName }, accessibleSites) => {
    $('#pageLoading').show()
    updateActiveSiteAction({ site_id: siteId })
      .then(response => {
        localStorage.setItem('siteId', siteId)
        localStorage.setItem('siteName', siteName)
        sessionStorage.setItem('siteId', siteId)
        sessionStorage.setItem('siteName', siteName)
        setLoginSiteData(prevState => ({
          ...prevState,
          siteName: siteName,
          activeSiteId: siteId,
          accessibleSites,
        }))
        $('#pageLoading').hide()
        Toast.success(' The current site is inactive and has been changed. You will be redirected to an active site.')
      })
      .catch(error => {
        $('#pageLoading').hide()
        Toast.error(error.tostMsg.msg)
      })
  }

  // change compnay
  const changeClientCompany = async comp => {
    $('#pageLoading').show()
    try {
      const { siteId, siteName } = comp.clientCompanyUsersites[0]
      const cc = await updateClientCompany({ company_id: comp.clientCompanyId, site_id: siteId })
      const ac = await UpdateActiveSiteService({ site_id: siteId })

      Toast.success('The current client company is inactive and has been changed. You will be redirected to an active client company.')

      setLoginSiteData(prevState => ({
        ...prevState,
        accessibleSites: comp.clientCompanyUsersites,
        activeClientCompanyId: comp.clientCompanyId,
        clientCompanyName: comp.clientCompanyName,
        siteName: siteName,
      }))

      localStorage.setItem('clientCompanyName', comp.clientCompanyName)
      localStorage.setItem('siteId', siteId)
      localStorage.setItem('siteName', siteName)
      localStorage.setItem('activeClientCompanyId', comp.clientCompanyId)
      sessionStorage.setItem('clientCompanyName', comp.clientCompanyName)
      sessionStorage.setItem('siteId', siteId)
      sessionStorage.setItem('siteName', siteName)
      sessionStorage.setItem('activeClientCompanyId', comp.clientCompanyId)
    } catch (error) {
      console.log(error)
      Toast.error('Something went wrong!')
    }
    $('#pageLoading').hide()
  }

  const reFetchFacilityData = async () => {
    reFetch()
    if (checkUserRole.isSuperAdmin()) {
      setRefetchAppMenuContext(true)
      localStorage.setItem('headerDataUpdate', Date.now())
    } else {
      await getUserFacilitiesData()
    }
  }

  const getUserFacilitiesData = async () => {
    try {
      const res = await getActiveUserSitesAndRoles(get(loginData, 'uuid', ''))
      if (res.success > 0) {
        const data = camelizeKeys(res.data)
        const clientCompany = get(data, 'clientCompany', []).find(d => d.clientCompanyId === getApplicationStorageItem('activeClientCompanyId'))
        const clientCompanyUsersites = !isEmpty(clientCompany) > 0 ? clientCompany.clientCompanyUsersites : []
        const currentActiveSite = clientCompanyUsersites.find(e => e.siteId === getApplicationStorageItem('siteId'))

        setLoginSiteData(prevState => {
          const updatedLoginSiteData = {
            ...prevState,
            defaultSiteName: get(data, 'defaultSiteName', ''),
            companyName: get(prevState, 'companyName', localStorage.getItem('companyName')),
            defaultCompanyName: get(prevState, 'defaultCompanyName', localStorage.getItem('defaultCompanyName')),
            userroles: get(data, 'userroles', []),
            client_company: get(data, 'clientCompany', []),
            accessibleSites: clientCompanyUsersites,
            activeClientCompanyId: get(clientCompany, 'clientCompanyId', prevState.activeClientCompanyId),
            clientCompanyName: get(clientCompany, 'clientCompanyName', prevState.clientCompanyName),
            activeSiteId: get(currentActiveSite, 'siteId', prevState.activeSiteId),
            siteName: get(currentActiveSite, 'siteName', prevState.siteName),
          }

          // // Update session storage
          Object.keys(updatedLoginSiteData).forEach(key => {
            sessionStorage.setItem(key, JSON.stringify(updatedLoginSiteData[key]))
          })
          sessionStorage.setItem('siteId', get(currentActiveSite, 'siteId', prevState.activeSiteId))
          //need to update localstorage as well due to when do open in new tab its taking new context state which will default take from localstorage
          localStorage.setItem('clientCompanyName', get(clientCompany, 'clientCompanyName', prevState.clientCompanyName))
          localStorage.setItem('activeClientCompanyId', get(clientCompany, 'clientCompanyId', prevState.activeClientCompanyId))
          localStorage.setItem('siteId', get(currentActiveSite, 'siteId', prevState.activeSiteId))
          localStorage.setItem('siteName', get(currentActiveSite, 'siteName', prevState.siteName))

          if (!isEmpty(clientCompanyUsersites) && !clientCompanyUsersites.some(e => e.siteId === updatedLoginSiteData.activeSiteId)) {
            handleSiteRadioClick(clientCompanyUsersites[0], clientCompanyUsersites)
          }
          if (isEmpty(clientCompany)) {
            changeClientCompany(get(data, 'clientCompany', [])[0])
          }

          if (!isEmpty(get(res, 'data.client_company', [])) || !isEmpty(get(res, 'data.usersites', []))) {
            // console.log('client company data - ', get(res, 'data.client_company', []))
            // console.log('site data - ', get(res, 'data.usersites', []))
            const loginData = JSON.parse(localStorage.getItem('loginData'))
            const updatedLoginData = {
              ...loginData,
            }
            if (!isEmpty(get(res, 'data.client_company', []))) {
              updatedLoginData.client_company = get(res, 'data.client_company', [])
            }
            if (!isEmpty(get(res, 'data.usersites', []))) {
              updatedLoginData.usersites = get(res, 'data.usersites', [])
            }
            localStorage.setItem('loginData', JSON.stringify(updatedLoginData))
          }
          localStorage.setItem('headerDataUpdate', Date.now())

          return updatedLoginSiteData
        })
      } else {
        Toast.error(res.message)
      }
    } catch (error) {
      console.log('error - ', error)
      Toast.error('Something went wrong !')
    }
  }

  const handleSiteView = data => {
    setAnchorObj(data)
    setOpenViewSite(true)
  }

  return (
    <div style={{ background: '#fff', height: 'calc(100vh - 64px)', width: '100%', margin: '20px 0 20px 0px' }}>
      <div className='d-flex justify-content-between align-items-center' style={{ width: '100%', marginBottom: '20px' }}>
        <div className='d-flex align-items-center'>
          <Button size='small' onClick={() => setOpenAddSite(true)} startIcon={<AddOutlined />} variant='contained' color='primary' className='nf-buttons' disableElevation>
            Create Facility
          </Button>
        </div>
        <SearchComponent placeholder='Search' searchString={searchString} setSearchString={setSearchString} />
      </div>
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ height: 'calc(100% - 115px)' }}>
        <TableComponent loading={loading} columns={columns} data={rows} onRowClick={d => handleSiteView(d)} isForViewAction={true} />
      </div>
      {isOpenAddSite && <AddSites open={isOpenAddSite} onClose={() => setOpenAddSite(false)} reFetch={reFetchFacilityData} stateData={stateData} clientCompanies={clientCompanies} />}
      {isOpenEditSite && <AddSites open={isOpenEditSite} onClose={() => setOpenEditSite(false)} reFetch={reFetchFacilityData} anchorObj={anchorObj} clientCompanyId={companyId} isEdit stateData={stateData} clientCompanies={clientCompanies} />}
      {isOpenViewSite && <ViewSite open={isOpenViewSite} onClose={() => setOpenViewSite(false)} siteDetails={anchorObj} />}
    </div>
  )
}

export default Sites
